// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import Common from "../Common";
import LinkedRoom from "../LinkedRoom";
import { getChatroomAddress } from "src/reducers";
import type { Message, ChatroomAddress } from "src/types";

type Props = {
  message: Message,
  address: ChatroomAddress,
};

const Reopen = ({ message, address }: Props) => {
  const { data, roomId } = message;
  const { id, comment } = data;
  const isCurrentRoom = id === parseInt(roomId, 10);
  if (isCurrentRoom)
    return (
      <Common {...message} comment={comment}>
        {" "}
        {i18n.t(k.REOPENED_THIS_CONVERSATION)}
      </Common>
    );

  return (
    <Common {...message} comment={comment}>
      {" "}
      {i18n.t(k.REOPENED)} <LinkedRoom id={id} chatroomAddress={address} />
    </Common>
  );
};

const mapStateToProps = ({ app }, { message }) => ({
  address: getChatroomAddress(app, message.data.id),
});

export default connect(mapStateToProps)(Reopen);
